<template>
  <v-container>
    <v-row>
      <v-col>
        <v-select
          v-model="selected"
          label="Cargas"
          :items="cargas"
          :filter="activeFilter"
          chips
          item-text="name"
          item-value="id"
          hide-details
          dense
          @change="getInforme"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.name }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">(+{{ selected.length - 1 }} others)</span>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <!-- <v-col>
        <ActivaReactiva />
      </v-col>-->
      <!-- 
      <v-col sm="6" xs="12">
        <OnOff :carga.sync="selected" v-if="selected" :loading="loaders.l1"/>
      </v-col>
      <v-col sm="6" xs="12">
        <ProporcionConsumo :carga="selected" v-if="selected" :loading="loaders.l2"/>
      </v-col>
      <v-col xs="12" sm="12">
        <CurvaComportamiento :carga="selected" v-if="selected" :loading="loaders.l3"/>
      </v-col>-->
      <v-col class="ds-informe">
        <iframe
          v-if="informe"
          width="100%"
          :src="informe"
          frameborder="0"
          style="border:0"
          allowfullscreen
        ></iframe>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Vue from "vue";
import { apiv1 } from "../../libs/apiv1";
import { API } from "../../globals";
import { Auth } from "../../classes/Auth";
// import OnOff from "./charts/OnOff";
// import CurvaComportamiento from "./charts/CurvaComportamiento";
// import ProporcionConsumo from "./charts/ProporcionConsumo";
// import ActivaReactiva from "./charts/ActivaReactiva";

export default Vue.extend({
  name: "Habitos",
  data: () => ({
    // loaders: {
    //   l1: true,
    //   l2: true,
    //   l3: true
    // },
    selected: null,
    cargas: [],
    informe: null
  }),
  // components: {
  //   OnOff,
  //   CurvaComportamiento,
  //   ProporcionConsumo,
  //   ActivaReactiva
  // },
  mounted() {
    this.getCargas();
  },
  computed: {
    activeFilter() {
      if (this.model == null) return undefined;
      return this.filters[this.model].fn;
    }
  },
  methods: {
    getInforme() {
      apiv1({
        method: "GET",
        url: `ceco/informe/${this.selected}`
      }).then(res => {
        console.log(res.data);
        this.informe = res.data.link;
      });
    },

    getCargas: function() {
      const auth = new Auth();

      let url = `user/cargas?user=${auth.getUser().id}`;
      if (auth.getUser().rol === "ADMIN" || auth.isVertebra()) {
        url = `user/cargas?project=${auth.getProject().id}`;
      }

      apiv1({
        method: "GET",
        url: url
      }).then(res => {
        this.cargas = res.data;
      });
    }
  }
});
</script>
<style lang="scss" scoped>

.container {
    // height: 100vh;
    // padding: 0;
    // display: flex;
    // justify-content: start;
  // align-items: center;
  padding: 0;

  .row {
    width: 100% !important;
  }

}


.ds-informe {
  position: relative;

  &::after {
    width: 100%;
    height: 40px;
    content: " ";
    display: block;
    position: absolute;
    background: #fff;
    bottom: 0;
    left: 0;
  }

  iframe {
    width: 100%;
    height: 100vh;
  }
}
</style>